import { render, staticRenderFns } from "./NoticesPage.vue?vue&type=template&id=0bb89a76"
import script from "./NoticesPage.vue?vue&type=script&lang=js"
export * from "./NoticesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports